<cap-bsg-header [welcomePage]="'/home/dashboard'" appTitleKey="layouts.page.title" [appLogo]="logoPath" alt="Logo">
  <li *ngIf="isMizenEnabled()">
    <cap-mizen-inbox></cap-mizen-inbox>
  </li>
  <li>
    <cap-user-picker [languages]="['de','fr']">
      <ng-container *ngIf="this.passwortAendernParam || this.emailAendern">
        <div *ngIf="this.passwortAendernParam">
          <a class="dropdown-item" target="_blank"
             [href]="keycloakPasswordChangeUrl">
            {{'layouts.passwortAendern' | translate}}
          </a>
        </div>
        <div *ngIf="this.emailAendern">
          <a class="dropdown-item" target="_blank" [href]="keycloakEmailChangeUrl">
            {{'layouts.emailAendern' | translate}}
          </a>
        </div>
        <div class="dropdown-divider"></div>
      </ng-container>
    </cap-user-picker>
  </li>
</cap-bsg-header>

<div class="bsg-content-wrapper">

  <nav id="navigation" [attr.aria-label]="'layouts.page.titleNavigation'|translate">
    <cap-environment-marker></cap-environment-marker>
    <cap-bsg-nav-menu>
      <ng-container *ngFor="let item of root?.activatedChildren">
        <cap-bsg-nav-item
          [deactivated]="item.deactivated"
          [url]="item.content.link"
          [labelKey]="item.content.text"
          [tooltipKey]="item.content.text"
          [icon]="item.content.icon"
          [href]="item.content.href" [target]="item.content.target">
          <ng-container *ngFor="let item2 of item?.activatedChildren">
            <cap-bsg-nav-item
              [deactivated]="item2.deactivated"
              [url]="item2.content.link"
              [labelKey]="item2.content.text"
              [tooltipKey]="item2.content.text"
              [icon]="item2.content.icon"
              [href]="item2.content.href" [target]="item2.content.target">
              <ng-container *ngFor="let item3 of item2?.activatedChildren">
                <cap-bsg-nav-item
                  [deactivated]="item3.deactivated"
                  [url]="item3.content.link"
                  [labelKey]="item3.content.text"
                  [tooltipKey]="item3.content.text"
                  [icon]="item3.content.icon"
                  [href]="item3.content.href" [target]="item3.content.target">
                </cap-bsg-nav-item>
              </ng-container>
            </cap-bsg-nav-item>
          </ng-container>
        </cap-bsg-nav-item>
      </ng-container>
    </cap-bsg-nav-menu>
  </nav>

  <main id="content" role="main">

    <cap-alert-list id="alert-wrapper"></cap-alert-list>

    <router-outlet></router-outlet>

  </main>

</div>

